import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cookie-message',
  templateUrl: './cookie-message.component.html',
  styleUrls: ['./cookie-message.component.scss']
})
export class CookieMessageComponent implements OnInit {

  public showMessage: boolean = false;
  public app: boolean = false;


  @ViewChild('cookieMessage') cookieMessage!: ElementRef;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

  
    if (this.getCookie() == true) {
      this.showMessage = false;
    } else {
      this.showMessage = true;
    }


    if (sessionStorage.getItem('app') == 'yes') {
        this.app = true;
    } else {
        this.app = false;
    }

  }


  /*
    verifica se mensagem de aceitar cookies foi aceita ou não
  */
  getCookie(): boolean {
    let name = "acceptedCookies=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return true;
        }
      }
      return false;
  }

  /*
    adiciona cookie que marca messagem de aceitar cookies como aceita
  */
  addCookie() {
    const d = new Date();
    d.setTime(d.getTime() + (30*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie ="acceptedCookies=yes;" + expires + ";path=/";
    this.cookieMessage.nativeElement.classList.add('animate__fadeOut');
    // setTimeout(() => {
    //     this.showMessage = false;
    // }, 1000)

  }

}
